var render, staticRenderFns
import script from "./rateList.vue?vue&type=script&lang=js&"
export * from "./rateList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cec92ba",
  null
  
)

export default component.exports